'use client'

import {type ReactNode} from 'react'
import {useSanityReferrerData} from '~/utils/useSanityReferrerData'
import {defaultHeroSubtitle, defaultHeroTitle} from '../constants'
import {PortableText} from '@portabletext/react'

type TitleProps = {
  title: ReactNode
}
export function Title(props: TitleProps) {
  const {title = defaultHeroTitle} = props
  const referrerData = useSanityReferrerData()

  if (!referrerData) return title

  const partnerTitle = referrerData.partner?.partnerLandingPageInfo?.title?.map(
    (line, ix) => (
      <span style={{display: 'block'}} key={ix}>
        {line}
      </span>
    )
  )

  if (!partnerTitle?.length) return title

  return <h1>{partnerTitle}</h1>
}

type SubtitleProps = {
  subtitle: ReactNode
}
export function Subtitle(props: SubtitleProps) {
  const {subtitle = defaultHeroSubtitle} = props

  const referrerData = useSanityReferrerData()

  if (!referrerData) return subtitle

  const partnerSubtitle = referrerData.partner?.partnerLandingPageInfo?.subtitle

  if (!partnerSubtitle) return subtitle

  return <PortableText value={partnerSubtitle} />
}
